module.exports = __webpack_public_path__ + "img/controller-none.df552e2f.png";